import React from 'react';
import { useSelector } from 'react-redux';

import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import moment from 'moment';

import { MISC_DATE_ISO_FORMAT, MISC_DATE_POLISH_DATE_ONLY_FORMAT } from '../../../../../core/constants';
import { getWarehouseDocumentState } from '../../../../../features/inventory/get_warehouse_document';

const DetailsList = () => {
    const getWarehouseDocument = useSelector(getWarehouseDocumentState);
    const positions = getWarehouseDocument?.data?.positions || [];

    const totalQuantity = positions.reduce((sum, item) => sum + (Number(item?.quantity) || 0), 0);
    const totalNet = positions.reduce((sum, item) => sum + ((Number(item?.quantity) || 0) * (Number(item?.netPrice) || 0)), 0);
    const totalGross = positions.reduce((sum, item) => sum + ((Number(item?.quantity) || 0) * (Number(item?.grossPrice) || 0)), 0);

    return (
        <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1 } }>
            <Typography variant="h6" gutterBottom sx={ { fontWeight: 600, mb: 2 } }>
                Pozycje dokumentu
            </Typography>
            <TableContainer component={ Paper } variant="outlined">
                <Table stickyHeader>
                    <TableHead>
                        <TableRow sx={ { '& th': { backgroundColor: 'slate.50', fontWeight: 600 } } }>
                            <TableCell>Produkt</TableCell>
                            <TableCell align="center">Ilość</TableCell>
                            <TableCell align="center">Partia</TableCell>
                            <TableCell align="center">Data ważności</TableCell>
                            <TableCell align="right">Cena netto</TableCell>
                            <TableCell align="right">Cena brutto</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        { positions.map(item => (
                            <TableRow key={ item?.warehouseBatchId } hover>
                                <TableCell sx={ { fontWeight: 500 } }>{ item?.product?.name }</TableCell>
                                <TableCell align="center">{ item?.quantity }</TableCell>
                                <TableCell align="center">{ item?.productBatchId || '-' }</TableCell>
                                <TableCell align="center">
                                    { moment(item?.expiryDate, MISC_DATE_ISO_FORMAT).format(MISC_DATE_POLISH_DATE_ONLY_FORMAT) }
                                </TableCell>
                                <TableCell align="right">{ item?.netPrice?.toFixed(2) } PLN</TableCell>
                                <TableCell align="right"
                                           sx={ { fontWeight: 600 } }>{ item?.grossPrice?.toFixed(2) } PLN</TableCell>
                            </TableRow>
                        )) }

                        { positions.length > 0 && (
                            <TableRow sx={ { '& td': { fontWeight: 600, backgroundColor: 'slate.50' } } }>
                                <TableCell align="right">Podsumowanie:</TableCell>
                                <TableCell align="center">{ totalQuantity }</TableCell>
                                <TableCell colSpan={ 2 }></TableCell>
                                <TableCell align="right">{ totalNet.toFixed(2) } PLN</TableCell>
                                <TableCell align="right">{ totalGross.toFixed(2) } PLN</TableCell>
                            </TableRow>
                        ) }

                        { positions.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={ 6 } align="center" sx={ { py: 3, color: 'text.secondary' } }>
                                    Brak pozycji na dokumencie.
                                </TableCell>
                            </TableRow>
                        ) }
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default DetailsList;